<br><br><br><br><br><br><br><br>
<p>
  FormPostulanteReactivo works!
</p>
<div class="container">
  <div class="row">
    <div class="col-md-12">
      <form class="bg-light p-3" [formGroup]="registrationForm">
        <div class="form-group">
          <label for="">Name</label>
          <input [class.is-invalid]="registrationForm.get('userName').invalid &&
                                     registrationForm.get('userName').touched " type="text" class="form-control" formControlName="userName">
              <small [class.d-none]="registrationForm.get('userName').valid || 
                                     registrationForm.get('userName').untouched" class="text-danger">User Name is very invalid !!</small>
        </div>
        <div class="form-group">
          <label for="">Password</label>
          <input type="password" class="form-control" formControlName="password">
        </div>
        <div class="form-group">
          <label for="">Confirm Password</label>
          <input type="password" class="form-control" formControlName="confirmPassword">
        </div>
        <div class="row" formGroupName="address">
          <div class="col-md-12">
            <div class="form-group">
              <label for="">City</label>
              <input type="text" class="form-control" formControlName="city">
            </div>
            <div class="form-group">
              <label for="">State</label>
              <input type="text" class="form-control" formControlName="state">
            </div>
            <div class="form-group">
              <label for="">Postal Code</label>
              <input type="text" class="form-control" formControlName="postalCode">
            </div>
          </div>
        </div>
        <button class="btn btn-primary" type="submit">Registrar</button>

      </form>
      <div class="alert alert-info my-3" >{{registrationForm.value | json}}</div>
    </div>
  </div>
</div>